export const HOME_ROUTE = '/';
export const DASHBOARD_ROUTE = '/dashboard';
export const ADD_POLICY_ROUTE = '/new';
export const EDIT_POLICY_ROUTE = '/edit/:id';
export const ADMIN_ROUTE = '/admin';
export const CHECKOUT_ROUTE = '/checkout';
export const OPERATIONS_ROUTE = '/operations';
export const OPERATIONS_ROUTE_POLICY_SCAN = '/operations/policyScan/:id/:sk?';
export const OPERATIONS_ROUTE_USER_DETAILS = '/operations/user/:id/:sk';
export const OPERATIONS_VIEW_DOC = '/operations/viewdoc';
export const OPERATIONS_ADVISER_CONNECT_DETAILS =
  '/operations/adviserConnect/:id/:sk';
export const OPERATIONS_POLICY_RENEWAL_DETAILS =
  '/operations/policyrenewal/:id/:sk/:familyId';
export const EXPLORE_ROUTE = '/explore';
export const ADVICE_ROUTE = '/advice';
export const EXPLORE_COVERAGE_ROUTE = '/explore/coverage'; // Insurance checkup
export const EXPLORE_CATEGORY_ROUTE = '/explore/category';
export const EXPLORE_DISCOVER_POLICY_SELECT_ROUTE = '/explore/policy';
export const EXPLORE_DISCOVER_POLICY_INFO_ROUTE = '/explore/policy/:policyName';
export const INVITATION_ROUTE = '/invitation';
export const LOGOUT_ROUTE = '/logout';
export const MARKET_SCAN_ROUTE = '/market-scan';
export const MARKET_SCAN_COMPARE_ROUTE = '/market-scan/compare';
export const MARKET_SCAN_COMPARE_POLICY_ROUTE = '/market-scan/compare/:id';
export const MARKET_SCAN_NEW_DEFAULT_ROUTE = '/market-scan/new';
export const MARKET_SCAN_NEW_ROUTE = '/market-scan/new/:policyTypeName?';
export const MARKET_SCAN_MBI_ROUTE = '/market-scan/mbi';
export const MARKET_SCAN_STATUS_ROUTE = '/market-scan/status';
export const MARKET_SCAN_LIFE_REFERRAL =
  '/market-scan/lifeReferral/:policyTypeName?';
export const MARKET_SCAN_PURCHASE_ROUTE = '/market-scan/purchase';
export const MARKET_SCAN_ONBOARDING_ROUTE = '/market-scan/onboarding';
export const MARKET_SCAN_RESULTS_ROUTE = '/market-scan-results';
export const MARKET_SCAN_RESULTS_LIFE_ROUTE = '/market-scan-results/life';
export const NOTIFICATIONS_ROUTE = '/notification';
export const ONBOARDING_START_ROUTE = '/onboarding/start';
export const ONBOARDING_MS_ROUTE = '/onboarding/compare/:policyType?';
export const ONBOARDING_TRACK_ROUTE = '/onboarding/track';
export const POLICIES_ROUTE = '/policies';
export const POLICY_DETAILS_ROUTE = '/policy/:id';
export const POLICY_DETAILS_DOCS_ROUTE = '/policy/:id/docs';
export const PROFILE_ROUTE = '/profile';
export const PROFILE_CREDIT_CARD_ROUTE = '/profile/credit-cards';
export const PROFILE_SHARE_ROUTE = '/profile/share';
export const WORKPLACE_ROUTE = '/profile/work';
export const WORKPLACE_OFFERS_ROUTE = `${WORKPLACE_ROUTE}/offers`;
export const RENEWAL_ROUTE = '/policy/:id/renewal';
export const RENEWAL_UPLOAD_ROUTE = '/policy/:id/renewal/upload';
export const RENEWAL_MANUAL_ROUTE = '/policy/:id/renewal/manual';
// Success screen for purchases completed on an external provider's site
// (e.g. Autosure) and confirmed back to us via the conversion webhook
export const EXTERNAL_PURCHASE_SUCCESS_ROUTE = '/external-purchase/success';
export const WINDCAVE_CALLBACK_BASE_ROUTE = '/windcaveCallback';
export const WINDCAVE_CALLBACK = `${WINDCAVE_CALLBACK_BASE_ROUTE}/:policyProvider/:status`;
export const WINDCAVE_CALLBACK_PROTECTA = `${WINDCAVE_CALLBACK_BASE_ROUTE}/protecta`;
export const WINDCAVE_CALLBACK_STAR = `${WINDCAVE_CALLBACK_BASE_ROUTE}/star`;

export const EXPLORE_COVERAGE_RESULTS_ROUTE = {
  pathname: EXPLORE_COVERAGE_ROUTE,
  state: {
    showResults: true,
  },
};

export const WORKPLACE_EDIT_ROUTE = {
  pathname: WORKPLACE_ROUTE,
  state: {
    fromDashboard: true,
  },
};
